// Google Analytics Ecommerce
import { pruneDigitalDataObj } from './GAUtil'
import { getAnalyticsModalData } from './Constants';

export function getSlimShoppingCart(cart) {
  const slimcart = [];
  cart.cartItems.forEach(
    (item) => {
      const product = {
        brand: item.materialInfo.manufacturerName,
        category: item.materialInfo.categoryId,
        productSku: item.materialInfo.manufacturerPartNumber,
        insightPartId: item.materialInfo.materialId,
        list: "Cart", // materialType?
        name: item.materialInfo.description,
        price: item.totalPrice,
        quantity: item.quantity
      }
      slimcart.push(product);
    }
  );
  return slimcart;
}

export function removeFromShoppingCartGAE(cart,...cartItems) {
  pruneDigitalDataObj();
  const products = cartItems.some(Array.isArray) ? cartItems.reduce((a, b) => a.concat(b)) : cartItems // flatten
  window.dataLayer = window.dataLayer || []

  function removeFromCartRevise(tmname, obj) {
    if (tmname == "atm") {
      delete obj.ecommerce.remove.products[0].id;
    } else if (tmname == "gtm") {
      delete obj.ecommerce.remove.products[0].productSku;
      delete obj.ecommerce.remove.products[0].insightPartId;
      delete obj.cart;
    }
    return obj;
  };
  const slimCart = getSlimShoppingCart(cart);
  // report on data to Analytics tools.
  const remove_from_cart = {
    event: 'removeFromCart',
    scEvent: 'scRemove', // atm
    ecommerce: {
      remove: {
        products: products,
      },
    },
    cart: slimCart,
  }
  //window.dataLayer.push(remove_from_cart)
  fireTagEvent('removeFromCart', remove_from_cart, removeFromCartRevise);
}

export function addToShoppingCartGAE(cartItems, items,isAccessoryModal) {
  if (cartItems.length === 0) return
  pruneDigitalDataObj();
  window.dataLayer = window.dataLayer || []

  function addToCartRevise(tmname, obj) {
    if (tmname == "atm") {
      delete obj.ecommerce.add.products[0].id;
    } else if (tmname == "gtm") {
      obj.ecommerce.add.products[0].id = obj.ecommerce.add.products[0].productSku;
      delete obj.ecommerce.add.products[0].productSku;
      delete obj.ecommerce.add.products[0].insightPartId;
      delete obj.cart;
    }
    return obj;
  };
  const slimCart = getSlimShoppingCart(cartItems)
  const add_to_cart = {
    event: 'addToCart',
    modal: getAnalyticsModalData(isAccessoryModal),
    ecommerce: {
      currencyCode: items[0].currency,
      add: {
        products: [...items],
      },
    },
    cart: slimCart
  }
  fireTagEvent('addToCart', add_to_cart, addToCartRevise);
}

export function processShoppingCartUpdatesGAE(newCart, oldCart, updates) {
  const oldContracts = oldCart.contracts;
  const updatedCartItems = updates.map((update) => {
    const updatedItem = oldContracts[update.contractID].cartItems[update.materialID]
    return {
      name: updatedItem.description,
      id: updatedItem.materialID,
      productSku: updatedItem.mfrPartNumber,
      insightPartId: updatedItem.materialID,
      price: updatedItem.price,
      brand: updatedItem.manufacturerName,
      category: updatedItem.categoryId,
      quantity: update.quantity - updatedItem.quantity,
      currency: updatedItem.currency,
    }
  })
  updatedCartItems.forEach((item) => {
    if (item.quantity < 0) {
      item.quantity = Math.abs(item.quantity)
      removeFromShoppingCartGAE(oldCart, item)
    } else {
      addToShoppingCartGAE(oldCart, [item])
    }
  })
  processShoppingCartGAE(newCart);
}

export function processShoppingCartGAE(pcart) {
  // report on data to Analytics tools.
  const products = pcart.cartItemsForEmail.map(
    (item) => {
      const product = {
        brand: item.manufacturerName,
        category: item.categoryId,
        productSku: item.mfrPartNumber,
        insightPartId: item.materialID,
        list: "Cart", // materialType?
        name: item.description,
        price: item.price,
        quantity: item.quantity
      }
      return product;
    }
  );
  const cart = {
    ecommerce: {
      scEvent: "scOpen",
      subTotal: pcart.subTotal,
      total: pcart.totalCost,
      currencyCode: pcart.currency,
      products: products
    }
  }
  fireTagEvent("cart", cart);
}
